import React,{useState} from "react"
import { Navbar} from "reactstrap"
import { connect } from "react-redux"
import classnames from "classnames"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons'
import {logoutWithJWT} from "@store/actions/auth/loginActions"
import NavbarUser from "./NavbarUser"
import { history } from "@src/history"

import { surrenderBattle}  from '@store/actions/socket/socket_actions';



const ThemeNavbar  = props => {
  const colorsArr = [ "primary", "danger", "success", "info", "warning", "dark"];
  const navbarTypes = ["floating" , "static" , "sticky" , "hidden"];
  const [showDropdown, setShowDropdown] = useState(false)
  const [showInventory, setShowInventory] = useState(false)
  const [showMarket, setShowMarket] = useState(false)
  const [showPlay, setShowPlay] = useState(false)

  const logo = "/img/bg/logo_BMN.svg"
  const toggleDropdown = () => {setShowDropdown(!showDropdown); setShowInventory(false); setShowPlay(false); setShowMarket(false)};
  const toggleInventory = () => {setShowDropdown(false); setShowInventory(!showInventory); setShowPlay(false); setShowMarket(false)};
  const toggleMarket = () => {setShowDropdown(false); setShowInventory(false); setShowPlay(false); setShowMarket(!showMarket)};
  const togglePlay = () => {setShowDropdown(false); setShowInventory(false); setShowMarket(false); setShowPlay(!showPlay)};

  return (
    <React.Fragment>
      <div className="content-overlay" />
      <Navbar
        className={classnames(
          "header-navbar navbar-expand-lg navbar navbar-with-menu ",
          {
            "navbar-dark": colorsArr.includes(props.navbarColor),
            "bg-primary":
              props.navbarColor === "primary" && props.navbarType !== "static",
            "home":
            window.location.pathname === '/',
            "bg-danger":
              props.navbarColor === "danger" && props.navbarType !== "static",
            "bg-success":
              props.navbarColor === "success" && props.navbarType !== "static",
            "bg-info":
              props.navbarColor === "info" && props.navbarType !== "static",
            "bg-warning":
              props.navbarColor === "warning" && props.navbarType !== "static",
            "bg-dark":
              props.navbarColor === "dark" && props.navbarType !== "static",
            "d-none": props.navbarType === "hidden" && !props.horizontal,
            "floating-nav":
              (props.navbarType === "floating" && !props.horizontal) || (!navbarTypes.includes(props.navbarType) && !props.horizontal),
            "navbar-static-top":
              props.navbarType === "static" && !props.horizontal,
            "fixed-top": props.navbarType === "sticky" || props.horizontal,
            "scrolling": props.horizontal && props.scrolling,
            "pvp":window.location.pathname === '/pvp',
            "battle":window.location.pathname === '/pvp/battle',

          }
        )}
      >

      <div className="navbar-wrapper">
        <div className="navbar-background">
          <div className="navbar-container content">
          {false && window.location.pathname !== '/' && <div className="divider_navbar"></div>}
          {false && window.location.pathname === '/' && <div className="divider_navbar_home"></div>}
            <div
              className="navbar-collapse d-flex justify-content-between align-items-center size-header"
              id="navbar-mobile">
                <div className="logo d-flex align-items-center">
                <div className="brand-logo">
                    <a href="/" onClick={(e)=>{
                        e.preventDefault();
                        history.push("/")
                    }}><img src={logo} style={{width: '135px', marginTop: '3px'}} alt="logo"/></a>
                  </div>
                    <div className="navbar-btn-groups">
                    <button
                        className={"btn btn-navbar mx-1 mob_button hide_mobile "+(window.location.pathname === '/' ? 'active' : '')}
                        onClick={()=>{history.push("/")}}>
                        <div className="hide_mobile" style={{height:'16.5px !important'}} >Home</div>
                  </button>
                   <div className="menu_dropdown">
                      <button onClick={toggleDropdown}
                        className={"btn btn-navbar mx-1 mob_button hide_mobile "+(['/tutorials','/library','/mining_calc'].includes(window.location.pathname) ? 'active' : '')}>
                        NBM Academy
                        <span className={!showDropdown ? "navbar_arrow" : "navbar_arrow navbar_arrow_open"}></span>
                      </button>
                    {showDropdown && 
                        <div className="item_dropdown">
                          <button
                            className={"item_dropdown_btn "+(window.location.pathname === '/tutorials' ? 'active' : '')}
                            onClick={()=>{history.push("/tutorials")}}>
                              Tutorials
                          </button>
                          <button 
                            className={"item_dropdown_btn "}
                            onClick={()=>{window.open("https://nbmofficialwiki.gitbook.io/nbm-shadow-depths/ ");toggleDropdown()}}>
                            NBM Wiki
                          </button>
                          <button
                            className={"item_dropdown_btn "+(window.location.pathname === '/library' ? 'active' : '')}
                            onClick={()=>{history.push("/library")}}>
                              Library
                          </button>
                          <button
                            className={"item_dropdown_btn "+(window.location.pathname === '/mining_calc' ? 'active' : '')}
                            onClick={()=>{history.push("/mining_calc")}}>
                              Calculator
                          </button>
                        </div>
                      }
                    </div>
                    <div className="menu_dropdown">
                      <button onClick={toggleMarket}
                        className={"btn btn-navbar mx-1 mob_button hide_mobile "+(['/market','/market_sales','/market_sales_weekly','/market_sales_monthly'].includes(window.location.pathname) ? 'active' : '')}>
                        Market
                        <span className={!showMarket ? "navbar_arrow" : "navbar_arrow navbar_arrow_open"}></span>
                      </button>
                    {showMarket && 
                        <div className="item_dropdown">
                          <button
                            className={"item_dropdown_btn "+(window.location.pathname === '/market' ? 'active' : '')}
                            onClick={()=>{history.push("/market")}}>
                               Marketplace
                          </button>
                          <button
                            className={"item_dropdown_btn "+(window.location.pathname === '/shop' ? 'active' : '')}
                            onClick={()=>{history.push("/shop")}}>
                                NBM Shop
                          </button>
                          <button
                            className={"item_dropdown_btn "+(window.location.pathname === '/market_sales' ? 'active' : '')}
                            onClick={()=>{history.push("/market_sales")}}>
                              History
                          </button>
                          <button
                            className={"item_dropdown_btn "+(window.location.pathname === '/market_sales_weekly' ? 'active' : '')}
                            onClick={()=>{history.push("/market_sales_weekly")}}>
                              Weekly Leaderboard
                          </button>
                          <button
                            className={"item_dropdown_btn "+(window.location.pathname === '/market_sales_monthly' ? 'active' : '')}
                            onClick={()=>{history.push("/market_sales_monthly")}}>
                              Monthly Leaderboard
                          </button>
                          {/* <button
                            className={"item_dropdown_btn "+(window.location.pathname === '/alchemist' ? 'active' : '')}
                            onClick={()=>{history.push("/alchemist")}}>
                              alchemist
                          </button> */}
                        </div>
                      }
                    </div>
                    {/* <button
                        className={"btn btn-navbar mx-1 mob_button hide_mobile "+(window.location.pathname === '/pvp' ? 'active' : '')}
                        onClick={()=>{history.push("/pvp")}}>
                        <span className="hide_mobile">PVP</span>
                    </button> */}
                     <div className="menu_dropdown">
                      <button onClick={togglePlay}
                        className={"btn btn-navbar mx-1 mob_button hide_mobile "+(["/mining","/mining_grid","/shadow_depths"].includes(window.location.pathname) ? 'active' : '')}>
                        Play
                        <span className={!showPlay ? "navbar_arrow" : "navbar_arrow navbar_arrow_open"}></span>
                      </button>
                    {showPlay && 
                        <div className="item_dropdown">
                          <button
                            className={"item_dropdown_btn "+(window.location.pathname === '/mining' ? 'active' : '')}
                            onClick={()=>{history.push("/mining")}}>
                              Arcadian Mining
                          </button>
                          <button
                            className={"item_dropdown_btn "+(window.location.pathname === '/mining_grid' ? 'active' : '')}
                            onClick={()=>{history.push("/mining_grid")}}>
                              Apertian region
                          </button>
                          <button
                            className={"item_dropdown_btn "+(window.location.pathname === '/shadow_depths' ? 'active' : '')}
                            onClick={()=>{history.push("/shadow_depths")}}>
                              Shadow depths
                          </button>
                          <button
                            className={"item_dropdown_btn "+(window.location.pathname === '/spin' ? 'active' : '')}
                            onClick={()=>{history.push("/spin")}}>
                                Spin and win
                          </button>
                        </div>
                      }
                    </div>
                    <div className="menu_dropdown">
                      <button onClick={toggleInventory}
                        className={"btn btn-navbar mx-1 mob_button hide_mobile "+(['/cards','/wallet','/arcadex'].includes(window.location.pathname) ? 'active' : '')}>
                        My Inventory
                        <span className={!showInventory ? "navbar_arrow" : "navbar_arrow navbar_arrow_open"}></span>
                      </button>
                    {showInventory && 
                        <div className="item_dropdown">
                          <button
                            className={"item_dropdown_btn "+(window.location.pathname === '/cards' ? 'active' : '')}
                            onClick={()=>{history.push("/cards")}}>
                              My Cards 
                          </button>
                          <button
                            className={"item_dropdown_btn "+(window.location.pathname === '/wallet' ? 'active' : '')}
                            onClick={()=>{history.push("/wallet")}}>
                              Wallet
                          </button>
                          <button
                            className={"item_dropdown_btn "+(window.location.pathname === '/arcadex' ? 'active' : '')}
                            onClick={()=>{history.push("/arcadex")}}>
                              My Arcadex
                          </button>
                        </div>
                      }
                    </div>
                    <button
                        className={"btn btn-navbar mx-1 mob_button "+(window.location.pathname === '/arcadia' ? 'active' : '')}
                        onClick={()=>{history.push("/arcadia")}}>
                        <span className="hide_mobile ">Arcadia</span>
                    </button>
                    </div>
                </div>
              <NavbarUser
                handleAppOverlay={props.handleAppOverlay}
                changeCurrentLang={props.changeCurrentLang}
                loggedInWith={
                  props.user !== undefined 
                    ? props.loggedInWith
                    : null
                }
              />
            </div>
          </div>
          </div>
        </div>
      </Navbar>
    </React.Fragment>
  )
}

const mapStateToProps = state => {
  return {
    user: state.authorizedUser.user,
    socket_user: state.socket.socket_user

  }
}

export default connect(mapStateToProps, {logoutWithJWT, surrenderBattle})(ThemeNavbar)
